<div *ngIf="!!form" class="controls" style="display: flex; gap: 10px" >
  <button mat-raised-button *ngIf="!isEditMode" color="accent" mat-button (click)="isEditMode = true">{{title}}</button>
  <button mat-raised-button *ngIf="isEditMode" color="primary" mat-button [disabled]="disableWhenInvalid?!form.dynForm.valid : false"
      (click)="submit()">SAVE</button>
  <button mat-flat-button *ngIf="isEditMode" color="secondary" mat-button (click)="form.dynForm.cancel(); isEditMode = false">CANCEL</button>
</div>
